import React from "react";

interface DeleteBlockModalProps {
  open: boolean;
  onClose: () => void;
  themeBox: boolean;
  blockId: string;
  blockName: string;
  onConfirmDelete: () => void;
  isDeleting?: boolean;
}

const DeleteBlockModal: React.FC<DeleteBlockModalProps> = ({
  open,
  onClose,
  themeBox,
  blockId,
  blockName,
  onConfirmDelete,
  isDeleting = false,
}) => {
  if (!open) return null;

  return (
    <div
      className={`fixed inset-0 z-50 flex items-center justify-center p-4 ${
        themeBox ? "bg-black/60" : "bg-black/40"
      }`}
    >
      <div
        className={`relative w-full max-w-md rounded-2xl shadow-xl border ${
          themeBox
            ? "bg-[#1E1E1E] text-gray-100 border-[#2C2C2C]"
            : "bg-white text-gray-900 border-gray-200"
        }`}
      >
        <button
          onClick={onClose}
          aria-label="Close"
          className={`absolute top-3 right-3 p-2 rounded-full ${
            themeBox ? "hover:bg-white/10" : "hover:bg-black/5"
          }`}
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
            <path d="M18.3 5.71 12 12l6.3 6.29-1.41 1.42L10.59 13.4 4.29 19.7 2.88 18.29 9.17 12 2.88 5.71 4.29 4.3l6.3 6.29 6.29-6.29z" />
          </svg>
        </button>

        <div className="px-6 py-6 text-center">
          <div
            className={`mx-auto mb-3 flex items-center justify-center w-12 h-12 rounded-full ${
              themeBox ? "bg-[#111111]" : "bg-gray-100"
            }`}
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  <path d="M19.5 5.5L19.0982 12.0062M4.5 5.5L5.10461 15.5248C5.25945 18.0922 5.33688 19.3759 5.97868 20.299C6.296 20.7554 6.7048 21.1407 7.17905 21.4302C7.85035 21.84 8.68108 21.9631 10 22" stroke="#C6D92C" strokeWidth="1.5" strokeLinecap="round"/>
  <path d="M20 15L13 21.9995M20 22L13 15.0005" stroke="#C6D92C" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  <path d="M3 5.5H21M16.0557 5.5L15.3731 4.09173C14.9196 3.15626 14.6928 2.68852 14.3017 2.39681C14.215 2.3321 14.1231 2.27454 14.027 2.2247C13.5939 2 13.0741 2 12.0345 2C10.9688 2 10.436 2 9.99568 2.23412C9.8981 2.28601 9.80498 2.3459 9.71729 2.41317C9.32164 2.7167 9.10063 3.20155 8.65861 4.17126L8.05292 5.5" stroke="#C6D92C" strokeWidth="1.5" strokeLinecap="round"/>
</svg>
          </div>
          <h3 className="text-lg font-semibold mb-2">Delete Block</h3>
          <p className={`${themeBox ? "text-gray-300" : "text-gray-600"} mb-6`}>
            Are you sure you want to delete "{blockName}"? This action cannot be
            undone.
          </p>

          <div className="flex items-center justify-center gap-3">
            <button
              type="button"
              onClick={onConfirmDelete}
              className="px-4 py-2 font-medium hover:opacity-90 text-white rounded-[10px] border"
              style={{
                border: "1px solid #D92C2C",
                background:
                  "radial-gradient(94.17% 100% at 52.48% 0%, rgba(217, 44, 44, 0.80) 0%, rgba(91, 16, 16, 0.80) 100%)",
              }}
              disabled={isDeleting}
            >
              {isDeleting ? "Deleting..." : "Confirm and delete"}
            </button>
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 font-medium hover:opacity-90 text-black rounded-[10px] border"
              style={{
                border: "1px solid var(--menu-active-border, #C6D92C)",
                background:
                  "radial-gradient(94.17% 100% at 52.48% 0%, rgba(198, 217, 44, 0.80) 0%, rgba(83, 91, 16, 0.80) 100%)",
              }}
              disabled={isDeleting}
            >
              Maybe later
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteBlockModal;
